import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { ILoadBulkImportEmployeesResponse } from '../models/bulk-import-employees.model';

export const acceptSelectedEmployeeUpdatesKey = 'acceptSelectedEmployeeUpdates';

export interface AcceptSelectedEmployeeUpdatesState {
  acceptSelectedEmployeeUpdatesResponse: any;
  acceptSelectedEmployeeUpdatesFailure: any;
  loaded: boolean;
}

export const initialState: AcceptSelectedEmployeeUpdatesState = {
  acceptSelectedEmployeeUpdatesResponse: undefined,
  acceptSelectedEmployeeUpdatesFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,

  on(actions.acceptSelectedUpdatesSuccess, (state, action) => ({
    ...state,
    sendSelectedEmployeeInviteResponse: action.response,
    loaded: true
  })),

  on(actions.acceptSelectedUpdatesFailure, (state, action) => ({
    ...state,
    acceptSelectedEmployeeUpdatesFailure: action.error
  }))
);

export const acceptSelectedEmployeeUpdates = (state: AcceptSelectedEmployeeUpdatesState) => state.acceptSelectedEmployeeUpdatesResponse;
